import styled from "styled-components";

import { StyledStepperStepProps } from "./CircularStepperStep.types";

const TRANSITION_DURATION = "300ms";
const TRANSITION_TIMING_FUNCTION = "ease-in-out";

const StyledCircularStepperStep = styled.div<StyledStepperStepProps>`
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	height: 100%;
	opacity: ${({ status }) => (status === "active" ? 1 : 0)};
	transition: opacity ${TRANSITION_DURATION} ${TRANSITION_TIMING_FUNCTION};
`;

export default StyledCircularStepperStep;
